module.exports = __webpack_public_path__ + "static/media/icon.a55f4170.svg";